module.exports = __webpack_public_path__ + "img/Peanuts.e53c901b.svg";